import { Alert } from '@material-ui/lab'
import React from 'react'
import useSpecIntelligenceFreshness from './useSpecIntelligenceFreshness'

/** Props for {@link SpecIntelligenceStaleBanner}. */
export interface SpecIntelligenceStaleBannerProps {
    /** The project to poll for changes. */
    projectId: string
    /** Section numbers that were analyzed in the report — polled for individual staleness. */
    sectionNumbers: string[]
    /** ISO date string of the currently displayed report — used as the staleness baseline. */
    reportRunDate: string
}

/**
 * Polls the analyzed sections for staleness and renders a yellow alert bar when
 * any section was modified after the report ran. Renders nothing while fresh.
 */
const SpecIntelligenceStaleBanner = ({ projectId, sectionNumbers, reportRunDate }: SpecIntelligenceStaleBannerProps) => {
    const { isStale } = useSpecIntelligenceFreshness(projectId, sectionNumbers, reportRunDate)

    if (!isStale) return null

    return <Alert severity="warning">Spec modified since last analysis. Click "Re-run Analysis" to get a fresh report.</Alert>
}

export default SpecIntelligenceStaleBanner
